import Vue from 'vue';
import MaskDirective from './mask.directive';

Vue.use(MaskDirective);
